import { client } from '@/api/client';

// Case-insensitive "find my own DriverProfile row" lookup, shared by every
// driver-facing page (LoadBoard, ActiveLoad, Financials, DriverProfile).
// An exact-match `.filter({ user_email: email })` misses a driver whenever
// their record's user_email casing doesn't match their auth session's email
// exactly -- e.g. an admin typed "Marcus@Co.com" into DriverFormModal before
// that field was normalized to lowercase on save. Prefers the Approved
// profile if the driver somehow has more than one row, otherwise falls back
// to the most recently updated.
export async function findMyDriverProfile(email) {
  if (!email) return null;
  const allProfiles = await client.entities.DriverProfile.list('-updated_date', 200);
  const matching = allProfiles.filter(p => p.user_email?.toLowerCase() === email.toLowerCase());
  return matching.find(p => p.approval_status === 'Approved') || matching[0] || null;
}
